import {RiCircleFill, RiCloseLine} from "react-icons/ri";
import React from "react";
import neverLandUtils from "../../utils/NeverLandUtils";


const PlayerDetailCard = ({playerData, setPlayerCode}) => {

  return (
      <div className="w-full max-w-[25rem] h-full bg-black bg-opacity-85 z-10 text-white p-2 rounded-lg">
        <div className="flex items-center">
          <p className="bg-lime-300 py-1 px-3 text-black rounded-lg w-[80%] mx-auto text-center font-bold text-sm"> {playerData.playerInfoText} </p>

          <button onClick={() => setPlayerCode(null)}>
            <RiCloseLine className="w-6 h-6 ml-2"/>
          </button>
        </div>

        {/* <-- 선수 정보 영역 --> */}
        <div className="h-[calc(100%-1.5rem)] overflow-y-scroll flex flex-col px-1">
          <div className="flex flex-col">
            <div className="flex flex-col">
              <p className="text-lg bg-gray-200 mb-1 text-black px-2 mt-3">강점</p>
              <div className="flex flex-col divide-y divide-gray-200 text-sm">
                {playerData.strongPoints?.map((data, index) => {
                  const match = data.match(/(.*?)(매우강함|강함)$/); // 텍스트와 상태 분리
                  const text = match?.[1] || "";
                  const stat = match?.[2] || "";

                  return (
                      <div key={index} className="flex flex-row justify-between w-full items-center py-0.5">
                        <p className="w-3/4">{text}</p>
                        <p className={neverLandUtils.classNames(stat === "강함" ? "bg-sky-300 text-black" : "bg-blue-600 text-white", "min-w-16 bg-amber-200 rounded-full px-1 text-center")}>
                          {stat}
                        </p>
                      </div>
                  )
                })}
              </div>

              <p className="text-lg bg-gray-200 mb-1 text-black px-2 mt-3">약점</p>
              <div className="flex flex-col divide-y divide-gray-200 text-sm">
                {playerData.weaknesses?.map((data, index) => {
                  const match = data.match(/(.*?)(매우약함|약함)$/); // 텍스트와 상태 분리
                  const text = match?.[1] || "";
                  const stat = match?.[2] || "";

                  return (
                      <div key={index} className="flex flex-row justify-between w-full items-center py-0.5">
                        <p className="w-3/4">{text}</p>
                        <p className={neverLandUtils.classNames(stat === "약함" ? "bg-amber-400 text-black" : "bg-rose-700 text-white", "min-w-16 bg-amber-200 rounded-full px-1 text-center")}>
                          {stat}
                        </p>
                      </div>
                  )
                })}
              </div>
            </div>

            <div className="flex flex-col mt-3">
              <p className="text-lg bg-gray-200 my-1 text-black px-2">스타일</p>
              {playerData.playStyles?.filter((data) => data.trim() !== "").map((data, index) => {
                return (
                    <div className="flex flex-row items-center text-sm" key={index}>
                      <RiCircleFill className="h-2 w-auto mr-2 text-gray-600"/>
                      <p className="py-0.5">{data}</p>
                    </div>
                );
              })}
            </div>

            <p className="text-lg bg-gray-200 my-1 text-black px-2">러닝타임 & 골여부 & 평점</p>
            <table className="mt-1 border border-white text-center">
              <tbody className="divide-y divide-gray-200">
              {playerData.prevPlayRecodes?.map((data, index) => {
                const [home, score, away, date, time, playTime, rating] = data.split('|'); // 데이터 분리
                return (
                    <tr key={index}>
                      <td className="py-0.5">{home}</td>
                      <td>{score}</td>
                      <td>{away}</td>
                      <td>{date}</td>
                      <td>{time}</td>
                      <td>{playTime}</td>
                      <td>{rating}</td>
                    </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
  )
}
export default PlayerDetailCard;